/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, message } from "antd";
import { Collapse, Form, Flex, Row, Col, Space } from "antd";
import { Input, Button, Table, Typography } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from '../../../hooks/useAccessPageState';
import ActiveStatusItem, {
  ACTIVE_STATUS_DEFAULT,
  withDefaultStatus,
} from "../../../components/form/ActiveStatusItem";
import RawMaterialService from "../../../service/ERP/RawMaterial.service";

import { delay } from "../../../utils/util";

const rmService = RawMaterialService();

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const RawMaterialAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      rmService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", ACTIVE_STATUS_DEFAULT);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: ACTIVE_STATUS_DEFAULT }, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "Create Raw Material",
          action: "create",
        },
      },
    });
  };

  /* โหมดดูอย่างเดียว — เปิดหน้าเดียวกับแก้ไขแต่ปิดการแก้ไขทั้งฟอร์ม */
  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View Raw Material",
          action: "view",
          code: data?.id,
        },
      },
    });
  };

  const handleEdit = (data) => {
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit RawMaterial",
          action: "edit",
          code: data?.id,
        },
      },
    });
  };

  const init = async () => {
    getData({});
  };

  useEffect(() => {
    const restored = restoreState();

    /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดการใช้งาน" */
    const values = withDefaultStatus(restored?.searchValues);
    form.setFieldsValue(values);

    handleSearch(values, restored?.tablePagination);

    return async () => {
      await delay(400);
      // console.clear();
    };
  }, []);

  const getData = (data) => {
    rmService
      .search(data)
      .then((res) => {
        const { data } = res.data;

        setAccessData(data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Request error!");
      });
  };
  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
            <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <Form.Item
                      label="RawMaterial Code."
                      name="rm_code"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter RawMaterial Code." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <Form.Item
                      label="Raw Material Name."
                      name="rm_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter RawMaterial Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <Form.Item
                      label="Express Name"
                      name="express_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Express Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <Form.Item
                      label="ชื่อที่ใช้สั่งซื้อ"
                      name="purchase_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Purchase Name." />
                    </Form.Item>
                  </Col>
                  <ActiveStatusItem onChange={handleSearch} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const allColumns = accessColumn({ handleView, handleEdit });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "raw_material_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Raw Material
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create Raw Material
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="packaging-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
          {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="id"
                columns={column}
                dataSource={accessData}
                scroll={{ x: 'max-content' }} 
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default RawMaterialAccess;
